<template>
  <div>
    <div class="d-flex justify-content-start align-items-end mb-2">
      <b-form-group label="Company" class="mr-2">
        <b-form-input v-model="filtersObj.companyName" size="sm" type="text" @input="onSearch"></b-form-input>
      </b-form-group>
      <b-form-group label="Invoice No" class="mr-2">
        <b-form-input v-model="filtersObj.invoiceId" size="sm" type="text" @input="onSearch"></b-form-input>
      </b-form-group>
      <b-form-group label="Purchase Order No" class="mr-2">
        <b-form-input v-model="filtersObj.purchaseOrderId" size="sm" type="text" @input="onSearch"></b-form-input>
      </b-form-group>
      <date-range-picker :dateFrom="filtersObj.dateFrom" :dateTo="filters.dateTo" @handleSearch="onSearch"></date-range-picker>
      <div class="clear-filter-button-container">
        <b-button size="sm" @click="handleClearFilter">Clear filters</b-button>
      </div>
    </div>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :canEdit="checkClaim(CAN_EDIT_CREDIT_MEMO)"
      :canDelete="checkClaim(CAN_DELETE_CREDIT_MEMO)"
      :gridId="gridId"
      :pageable="pageable"
      :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
      :take="pageInfo.pageSize"
      :itemData="itemData"
      :pageSizes="pageInfo.pageSize"
      :totalItems="pageInfo.totalItems"
      :fields="fields"
      :sortBy="pageInfo.sortBy"
      :sortOrder="pageInfo.sortOrder"
      :sortMethod="sortGrid"
      :onDelete="onDelete"
      :onEdit="onEdit"
      :handleRowClick="handleRowClick"
      @getData="onGetData"
      :styleCustom="'height: 335px'"
      :isTblLoader="tblLoader"
    />
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import debounce from 'lodash/debounce';
  import { GRID_PAGE_SIZES, GRID_ID } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
  import gridFields from '../../fields';

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    name: 'NonRefundMemos',
    components: {
      GridSettings,
      GridComponent,
      DateRangePicker,
    },
    metaInfo: () => ({
      title: 'Non-Refund CreditMemos',
    }),
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.CREDITMEMOS,
        pageable: {
          pageSizes: GRID_PAGE_SIZES,
        },
        selectedRowItemId: 0,
        filterPageName: 'creditMemoPage'
      };
    },
    props: {
      refreshGrid: {
        type: [String, Number],
        default: 0,
      },
    },
    computed: {
      ...mapGetters('creditMemos', [
        'gridList',
        'creditMemo',
        'pageInfo',
        'filters',
        'tblLoader'
      ]),
      ...mapGetters('account', ['gridSettingsById']),

      itemData() {
        if(this.gridList == undefined || this.gridList.length === 0) return [];
        return this.gridList.map((CreditMemo) => ({ ...CreditMemo, selected: CreditMemo.id === this.selectedRowItemId }));
      },

      filtersObj() {
        return this.filters[this.filterPageName] || {}
      },
    },
    methods: {
      ...mapMutations('creditMemos', [
        'setItem'
      ]),
      ...mapActions('creditMemos', ['getAll',
        'getcreditMemoById',
        'manageCreditMemo',
        'sortGrid',
        'deleteCreditMemo',
        'search',
        'selectcreditMemos']),
      ...mapActions('account', ['saveGridSettings']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      onSearch: debounce(function(data = false) {
        if(typeof data === 'object') { Object.assign(this.filters,data) }
        this.filtersObj.isRefund = false;
        this.search({'filters':this.filtersObj,page:this.filterPageName});
      }, SEARCH_DEBOUNCE_TIME),
      async handleClearFilter() {
        this.clearObject(this.filtersObj);
        this.filtersObj.isRefund = false;
        this.search({'filters':this.filtersObj,page:this.filterPageName});
      },
      onEdit(props) {
        //this.setCreditMemo(props);
        //this.$bvModal.show('credit-memo-modal');
      },
      handleRowClick(row) {
        //this.setLastOpenedId(row.dataItem.id);
        //this.selectedRowItemId = row.dataItem.id;
      },
      async onDelete(row) {
        const deleteConfirmed = await this.openConfirmBox({message:'Are you sure you want to delete record?  This action cannot be undone.'});
        if (deleteConfirmed) {
          await this.deleteCreditMemo(row.id);
          //Get the data
          this.updateList();
        }
      },
      async onGetData(params) {
        await this.getAll(params);
      },
      async updateList() {
          await this.getAll({});
      },
    },
    watch:{
      refreshGrid(value){
        if(value == 1){
          this.updateList()
        }
      }
    },
    async mounted() {
      this.setItem({ resource:'filterPage', payload: this.filterPageName });
      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      await this.getAll({});
    }
  }
</script>

<style scoped>

</style>